import { createElement } from 'react'
import { EndView } from './view'

import routesEnum from '../Routes/enum'

import { Navigate, useLocation } from 'react-router-dom'

function EndContainer() {
	const location = useLocation()

	const { state, pathname } = location as any
	

	const pageProps: any = {
		...state
	}

	return createElement(EndView, pageProps)
}

export { EndContainer }
